export default "__VITE_ASSET__CReS44FI__"